import React from 'react'
import { ReactComponent as IconGenderFelame } from '../../../../assets/icons/icon-gender-female.svg'
import { ReactComponent as IconGenderMale } from '../../../../assets/icons/ico-gender-male.svg'
import { ReactComponent as Rabbit } from '../../../../assets/icons/rabbit-regular.svg'
import { ReactComponent as Cat } from '../../../../assets/icons/cat-regular.svg'
import { ReactComponent as Dog } from '../../../../assets/icons/dog-regular.svg'
import { ReactComponent as DefaultPetIcon } from '../../../../assets/icons/default-pet-icon-regular.svg'

export const GENDER_ICON = {
  MALE: <IconGenderMale />,
  FEMALE: <IconGenderFelame />
}
export const PET_TYPE_ICON = {
  DOG: <Dog />,
  CAT: <Cat />,
  RABBIT: <Rabbit />,
  PIGGY_INDIAN: <Rabbit />,
  FERRET: <Rabbit />,
  DEFAULT: <DefaultPetIcon />
}
export const NOT_FOUND_INFO = 'Não preenchido'
